<template>
  <div id="app">
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import "./assets/css/index.css";

.el-dialog__footer {
  padding: 0 !important;
  height: 70px !important;
  display: flex;
  align-items: center;
  justify-content: right;
  margin-right: 20px;
}

.el-scrollbar {
  /* display: block !important; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue